import * as R from "ramda";
import React, { useMemo } from "react";
import { getValue } from "../../utils";
import { getInitials } from "utils/General/noLib";
import Tooltip from "components/Global/Tooltip";

const sortValues = R.sort((a, b) => {
  return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
});

const EventListFormatter = props => {
  const value = getValue(props);
  const list = useMemo(() => sortValues(value), [value]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      {list.map(e => (
        <Tooltip key={e.id} tooltip={e.name}>
          <div
            style={{
              backgroundColor: e.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "600",
              marginLeft: "4px",
              width: "25px",
              height: "25px",
              borderRadius: "4px"
            }}
          >
            {getInitials(e.name, true)}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default EventListFormatter;
